import type { EventInput } from "@fullcalendar/core";
import { addHours, set } from "date-fns";

import { CalendarResponseEvent } from "./calendar-types";

export function getDefaultActionDate(
  date: Date,
  useClickedTime: boolean,
): Date {
  if (useClickedTime) {
    return set(new Date(date), { seconds: 0, milliseconds: 0 });
  }
  return set(new Date(date), {
    hours: 9,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });
}

export function getDefaultEventEndDate(start: Date): Date {
  return addHours(start, 1);
}

export function isCalendarEventEditable(
  event: CalendarResponseEvent,
  canEdit: boolean,
): boolean {
  if (!canEdit) {
    return false;
  }
  if (event.isGenerated) {
    return false;
  }
  if (event.eventType === "background") {
    return false;
  }
  return event.type === "event";
}

export function toFullCalendarEvents(
  events: CalendarResponseEvent[],
  canEdit: boolean,
): EventInput[] {
  return events.map((event) => {
    const eventEditable = isCalendarEventEditable(event, canEdit);
    return {
      id: event.id,
      title: event.title || "",
      start: event.from,
      end: event.to || undefined,
      backgroundColor: event.color,
      borderColor: event.color,
      display: event.eventType === "background" ? "background" : "auto",
      editable: eventEditable,
      startEditable: eventEditable,
      durationEditable: eventEditable,
      extendedProps: { sourceEvent: event },
    };
  });
}
